export default __webpack_public_path__ + "static/media/button_point-on.9c0a0d67.svg";